document.addEventListener('DOMContentLoaded', function() {
  // Get all dropdown menus
  const dropdownMenus = document.querySelectorAll('.header__inline-menu details');
  
  dropdownMenus.forEach(menu => {
    // Add mouseover event listener (only once per element)
    menu.addEventListener('mouseenter', () => {
      menu.setAttribute('open', true);
    });
    
    // Add mouseleave event listener (only once per element)
    menu.addEventListener('mouseleave', () => {
      menu.removeAttribute('open');
    });
  });
});